// extracted by mini-css-extract-plugin
export default {"loginBackground":"login_loginBackground__qN8ce","container":"login_container__qUfK3","form":"login_form__OIfO+","logo":"login_logo__G40Ua"};